/**
 * Pre carga una lista de URLs de imagen.
 * Resuelve cuando todas cargaron (o fallaron) o al cumplirse el timeout.
 * @param {string[]} urls - URLs de imágenes (se filtran vacías)
 * @param {number} timeoutMs - Tiempo máximo de espera en ms (0 = sin límite)
 * @returns {Promise<void>}
 */
export function preloadImages(urls, timeoutMs = 0) {
  const valid = (urls || []).filter((u) => u && typeof u === 'string' && u.trim() !== '');
  if (valid.length === 0) return Promise.resolve();

  const loadOne = (url) =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve();
      img.onerror = () => resolve(); // No fallar si una imagen falla
      img.src = url;
    });

  const allLoaded = Promise.all(valid.map(loadOne)).then(() => {});

  if (timeoutMs <= 0) return allLoaded;

  return Promise.race([
    allLoaded,
    new Promise((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
}
